import React from 'react'
import EditHotelWorker from './edit'
import { Link, withRouter } from 'react-router-dom'
import HotelForm from '../components/form/form.component'
import HotelImages from '../components/images/images.component'
import FormHelper from '../../../../utils/FormHelper'
import './edit.styles.scss'
import Dialog from '../../../../components/dialog/dialog.component'
import Loading from '../../../../components/loading/loading.component'

class EditHotel extends React.Component {

    constructor(props) {
        super(props)
        this.editHotelWorker = EditHotelWorker(this)
        this.state = this.editHotelWorker.getDefaultState()
    }

    componentDidMount(){
        this.editHotelWorker.loadHotel()
    }

    onSubmit = (e) => {
        e.preventDefault()
        this.editHotelWorker.isValid() && this.editHotelWorker.updateHotel()
    }

    onCancel = () => this.props.history.push('/content/hotels')

    render() {
        return (
            <div className="edit-hotel">
                {
                    (this.state.loadingHotel || this.state.updatingHotel) && <Dialog><Loading /></Dialog>
                }
                <div className="card">
                    <Link className="btn" to="/content/hotels">Hotels</Link>
                    <div className="header">
                        <h4>Edit Hotel</h4>
                    </div>
                    <div className={"flag " + this.state.flag.type}>
                        {this.state.flag.text}
                    </div>
                    <HotelForm {...this.state} action="Save Hotel" onChange={FormHelper(this).onChange} onSubmit={this.onSubmit} onCancel={this.onCancel}>
                        <HotelImages hotelId={this.state.id} images={this.state.images} />
                    </HotelForm>
                </div>
            </div>
        )
    }
}

export default withRouter(EditHotel)
